// extracted by mini-css-extract-plugin
export default {"right-column":"Columns_right-column__8eASC","left-column":"Columns_left-column__vT4dN"};